export default {"gitHash":"c6faa80a48ad3c24da157ce39d13b11df677d46f","gitHashShort":"c6faa80","time":1645289563924,"platform":"linux","arch":"x64"};